import { useState } from "react";
import MaterialTable from "@material-table/core";
import Footer from "../../../../components/shared/Footer";
import DateRangePicker from "../../../../components/shared/DateRangePicker";
import { AutofileService } from "../../../../services/SubmissionService";
import { AnalyticsMaster, AnalyticsMasterRequest } from "../../../../models";
import AnalyticsDetailTable from "./AnalyticsDetailTable";

const defaultFromDate = () => {
    const newDate = defaultToDate();
    newDate.setHours(newDate.getHours() - 12);
    return newDate;
};

const defaultToDate = () => {
    const newDate = new Date();
    return newDate;
};

export default function AnalyticsPage() {
    const [fromDateTime, setFromDateTime] = useState<Date>(defaultFromDate());
    const [toDateTime, setToDateTime] = useState<Date>(defaultToDate());
    const [data, setData] = useState<Array<AnalyticsMaster>>(
        [] as Array<AnalyticsMaster>
    );

    const masterCall = () => {
        console.log(fromDateTime.toISOString());
        console.log(toDateTime.toISOString());
        AutofileService.getMaster({
            body: {
                fromDateTime: fromDateTime,
                toDateTime: toDateTime,
            } as AnalyticsMasterRequest,
        })
            .then((res) => {
                if (res.data && res.successful) {
                    const data__working: Array<AnalyticsMaster> =
                        res.data ?? [];
                    if (res.data.length > 100) {
                        alert(
                            "eFileMadeEasy Found More than 100 Results. Truncating"
                        );
                        data__working.length = 100;
                    }
                    if (res.data.length === 0) {
                        alert("eFileMadeEasy Did not find any results.");
                    }
                    setData(data__working);
                } else {
                    console.error(res.errorMessage);
                }
            })
            .catch((err) => {
                alert(err.message);
            });
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title"> Analytics </h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Jobs</a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            AutoFile
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Analytics
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        <h4 className="card-title">Filing Analyticts</h4>
                        <DateRangePicker
                            fromDateTime={fromDateTime}
                            toDateTime={toDateTime}
                            setToDateTime={setToDateTime}
                            setFromDateTime={setFromDateTime}
                        />
                        <div
                            className="row"
                            style={{
                                margin: "10px 0 0 0",
                                position: "relative",
                                width: "10%",
                            }}
                        >
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => masterCall()}
                            >
                                Search &nbsp;
                                <i className="ri-search-fill"></i>{" "}
                            </button>
                        </div>
                    </div>
                    <div className="card-body">
                        {/* TODO: Move to a new component */}
                        <MaterialTable
                            columns={[
                                { title: "Submission Count", field: "count" },
                                { title: "Attorney Name", field: "fullName" },
                                { title: "Attorney ID", field: "attorneyID" },
                                {
                                    title: "Document Type",
                                    field: "documentType",
                                },
                                { title: "County", field: "county" },
                            ]}
                            data={data}
                            title={"Master Analytics"}
                            options={{
                                actionsColumnIndex: -1,
                                pageSizeOptions: [5, 10, 20, 50, 75, 100],
                            }}
                            detailPanel={[
                                {
                                    tooltip: "Show Details By Document Type",
                                    render: (rowdata) => {
                                        return <></>;
                                    },
                                },
                            ]}
                        />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
